module.exports = __webpack_public_path__ + "img/linkedin.66b32d08.svg";